module.exports = __webpack_public_path__ + "static/media/icon-search.b7dd8466.svg";